
import { TextFieldHelper } from "@goodgamestudios/core";
import { getDefinitionByName } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2PopUpAchievementDialogProperties } from "./Poker2PopUpAchievementDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2PopUpAchievementDialog extends Poker2Dialog {
    public static NAME: string = "Poker2PopUpAchievementDialog";
    private MAX_ITEM_WIDTH: number = 60;
    private MAX_ITEM_HEIGHT: number = 60;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }
    protected init(): void {
        super.init();
        this.bonusDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.bonusDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_tableend_title");
        // TextFieldHelper.changeTextFromatSizeByTextWidth( 9, bonusDialog.txt_copy_1, Poker2Model.languageData.getTextById("dialog_achievement_copy1") );
        // TextFieldHelper.changeTextFromatSizeByTextWidth( 9, bonusDialog.txt_copy_6, Poker2Model.languageData.getTextById("dialog_achievement_copy6") ); // deine belohnung:
        this.bonusDialog.mc_appoint.toolTipText = Poker2Model.languageData.getTextById("tooltip_achievementPoints");
        this.bonusDialog.mc_appoint.mouseChildren = false;
        this.bonusDialog.mc_xppoint.toolTipText = Poker2Model.languageData.getTextById("tooltip_xpPoints");
        this.bonusDialog.mc_xppoint.mouseChildren = false;
    }
    protected applyProperties(): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.bonusDialog.txt_achi_name, this.bonusDialogProperties.achievementName);
        this.bonusDialog.txt_rank.text = String(this.bonusDialogProperties.achievementRank);
        this.bonusDialog.txt_xp_value.text = NumberStringHelper.groupString(this.bonusDialogProperties.achievement.bonusXP, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.bonusDialog.txt_ap_value.text = NumberStringHelper.groupString(this.bonusDialogProperties.achievement.bonusAP, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        var visClassName: string = this.bonusDialogProperties.achievement.getVisClassName();
        this.drawAchievement(this.bonusDialog.mc_holder_right, visClassName);
        //
        var str: string = Poker2Model.languageData.getTextById("dialog_achievement_copy1")
            + " " + this.bonusDialogProperties.achievementName
            + " " + Poker2Model.languageData.getTextById("dialog_achievement_copy3", [this.bonusDialogProperties.achievementRank]);
        this.bonusDialog.txt_copy.text = str;
    }
    private drawAchievement(mc_holder: MovieClip, visClassName: string): void {
        var mcClass: any = getDefinitionByName(visClassName) as any;
        var achievementMCLeft: MovieClip = new mcClass();
        var bounds: Rectangle = achievementMCLeft.getBounds(null);

        var scaleFactor: number = (this.MAX_ITEM_WIDTH / bounds.width);
        if ((bounds.height * scaleFactor) > this.MAX_ITEM_HEIGHT)
            scaleFactor = (this.MAX_ITEM_HEIGHT / bounds.height);

        achievementMCLeft.scaleX = achievementMCLeft.scaleY = scaleFactor;
        achievementMCLeft.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        achievementMCLeft.y = - ((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));

        while (mc_holder.numChildren > 0)
            mc_holder.removeChildAt(0);
        mc_holder.addChild(achievementMCLeft);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.bonusDialog.btn_ok:
                this.hide();
                break;
        }
    }
    protected get bonusDialogProperties(): Poker2PopUpAchievementDialogProperties {
        return this.properties as Poker2PopUpAchievementDialogProperties;
    }

    private get bonusDialog(): Library.PokerPopUps.Poker2PopUpAchievement {
        return this.disp as Library.PokerPopUps.Poker2PopUpAchievement;
    }
}
